import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const rupees = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

/** Combos whose barcode has an MRP in several channels (none is the plan's) — staff tap the channel for each, then print. */
export const ChannelPickDialog = ({ ask, chosen, onChoose, onPrint, onCancel }) => {
  if (!ask) return null;
  const ready = ask.every((b) => chosen[b.session_id]);
  return (
    <Dialog open onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-lg" data-testid="channel-pick-dialog">
        <DialogHeader>
          <DialogTitle>Pick the price channel</DialogTitle>
          <DialogDescription>
            {ask.length > 1 ? 'These combos have' : 'This combo has'} an MRP in more than one channel. Tap the one to print on the stickers.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 max-h-[55vh] overflow-y-auto">
          {ask.map((b) => (
            <div key={b.session_id} className="rounded-lg border p-3" data-testid={`channel-pick-${b.session_id}`}>
              <div className="text-sm"><span className="font-mono font-semibold">{b.combo_barcode}</span> <span className="text-stone-500">{b.design_name} / {b.shade} / {b.size}</span></div>
              <div className="mt-2 flex flex-wrap gap-2">
                {b.pricing.options.map((o) => (
                  <button key={o.pricing_type} type="button" onClick={() => onChoose(b.session_id, o.pricing_type)}
                    data-testid={`channel-opt-${b.session_id}-${o.pricing_type}`}
                    className={`rounded-md border px-3 py-2 text-left transition-colors ${chosen[b.session_id] === o.pricing_type ? 'border-green-600 bg-green-50 ring-1 ring-green-600' : 'border-stone-300 bg-white hover:bg-amber-50'}`}>
                    <div className="text-sm font-semibold">{o.pricing_type}</div>
                    <div className="text-xs text-stone-600">MRP {rupees(o.mrp)}</div>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} data-testid="channel-pick-cancel">Cancel</Button>
          <Button className="bg-green-600 hover:bg-green-700" disabled={!ready} onClick={onPrint} data-testid="channel-pick-print">Print</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChannelPickDialog;
